import React from "react";
import { Handle, Position } from "@xyflow/react";
import { FaRobot } from "react-icons/fa";

export default function SendToAINode({ data, selected }) {
  return (
    <div
      className={`rounded-xl border-2 bg-surface-card shadow-sm min-w-[180px] transition-shadow ${
        selected ? "border-indigo-500 shadow-md" : "border-surface-border"
      }`}
    >
      {/* Input handle */}
      <Handle
        type="target"
        position={Position.Top}
        className="!w-3 !h-3 !bg-indigo-500 !border-2 !border-white"
      />

      {/* Header */}
      <div className="flex items-center gap-2 px-3 py-2 rounded-t-[10px] bg-indigo-500">
        <FaRobot size={11} className="text-white" />
        <span className="text-xs font-semibold text-white">Send to AI</span>
      </div>

      {/* Body */}
      <div className="px-3 py-2.5">
        {data.prompt ? (
          <p className="text-xs text-ink-muted line-clamp-2">{data.prompt}</p>
        ) : (
          <p className="text-xs text-ink-muted italic">Click to configure AI</p>
        )}
      </div>

      {/* Output handle */}
      <Handle
        type="source"
        position={Position.Bottom}
        className="!w-3 !h-3 !bg-indigo-500 !border-2 !border-white"
      />
    </div>
  );
}
